// extracted by mini-css-extract-plugin
module.exports = {"modal":"OrganizationSwitchModal_modal__2VwuZ","content":"OrganizationSwitchModal_content__2GU8t","button":"OrganizationSwitchModal_button__1ilwo"};